var React = require('react');

function Size (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("ellipse",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"2.4","rx":"7.2","ry":"1.6","key":0}),React.createElement("ellipse",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"13.6","rx":"7.2","ry":"1.6","key":1}),React.createElement("ellipse",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","rx":"7.2","ry":"1.3","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"0.8","y1":"2.4","x2":"0.8","y2":"13.6","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"15.2","y1":"13.6","x2":"15.2","y2":"2.4","key":4})]));
}

Size.displayName = "Size";

Size.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Size;

Size.default = Size;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/size.svg
// module id = ../icon/src/icons/size.svg
// module chunks = 0